const reducer = state => {
  return {
    ...state,
    giftCardToken: null,
    waiting: true,
  };
};

export default reducer;
